import { useEffect, useState } from 'react';

type TimeLeft = { h: number; m: number; s: number };

const START_SPOTS = 78;
const MAX_SPOTS = 94;

function getTimeUntilMidnight(): TimeLeft {
  const now = new Date();
  const midnight = new Date(now);
  midnight.setHours(24, 0, 0, 0);
  const seconds = Math.max(0, Math.floor((midnight.getTime() - now.getTime()) / 1000));
  return {
    h: Math.floor(seconds / 3600),
    m: Math.floor((seconds % 3600) / 60),
    s: seconds % 60,
  };
}

function getSpotsTaken(): number {
  // Sube 1% cada 45 minutos a lo largo del día, entre 78% y 94%.
  const now = new Date();
  const minutesToday = now.getHours() * 60 + now.getMinutes();
  return Math.min(MAX_SPOTS, START_SPOTS + Math.floor(minutesToday / 90));
}

export function useLaunchCountdown() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(getTimeUntilMidnight);
  const [spotsTaken, setSpotsTaken] = useState<number>(getSpotsTaken);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(getTimeUntilMidnight());
      setSpotsTaken(getSpotsTaken());
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);

  return { timeLeft, spotsTaken };
}
